import React from "react";
import { useNavigate } from "react-router-dom";
import { intakeBrand, practiceFeatures, practiceContact } from "../../config/practice";

// departmentid: the intake's location (PatientOnboarding's route). 9928 shows
// that location's phone, mailbox and site (config/practice.js intakeBrand):
// CODE's on /onboard-code, C-HIM's everywhere else and for callers that pass
// none, as before.
const ConfirmAgreementModal = ({ open, onFinalAgree, departmentid }) => {
  const navigate = useNavigate();

  if (!open) return null;
  const brand = intakeBrand(departmentid);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white text-start rounded-lg shadow-lg w-[90%] max-w-lg p-6">
        <h2 className="text-xl font-bold mb-4">New Patient Disclaimer</h2>

        <p className="text-gray-700 mb-6">
          You must agree to the terms and conditions to continue with your new
          patient paperwork.  
          {/* 9928's phone and mailbox (C-HIM's, or CODE's on a CODE intake):
              9928 only (config/practice.js). */}
          {practiceFeatures().chimContact && (<>
          {" "}If you have questions, contact us at:  
          <strong> {brand.contact.phone} </strong> or  
          <strong> {brand.contact.email}</strong>
          </>)}
          {/* Another practice: its own phone when the profile has one (7825;
              OSA has no public mailbox). */}
          {!practiceFeatures().chimContact && practiceContact().phone && (<>
          {" "}If you have questions, contact us at:{" "}
          <strong>{practiceContact().phone}</strong>
          </>)}
        </p>

    <div className="flex flex-col sm:flex-row justify-end gap-4 w-full">
  <button
    className="px-5 py-2 rounded bg-gray-300 hover:bg-gray-400 w-full sm:w-auto"
    onClick={() => {
      // 9928 sends the patient to its public site; any other practice has
      // no site configured here, so go back to where the patient came from.
      if (practiceFeatures().chimContact) window.location.href = brand.site;
      else window.history.back();
    }}
  >
    I Don't Agree
  </button>

  <button
    className="px-5 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto"
    onClick={onFinalAgree}
  >
    I Agree
  </button>
</div>

      </div>
    </div>
  );
};

export default ConfirmAgreementModal;
